import {
    NavigationItem,
    NavigationItemIconPosition
} from '../../elements/components/navigation-item/entities/navigation-item.entity';
import { QueryIteratorStack, QueryIteratorStackEntry } from '../entities/query-iterator-stack.entity';
import { ActiveElementReference } from '../services/query-state-handler.service';

export function getBackToSearchNavigationItem(
    el: ActiveElementReference | undefined,
    stack: QueryIteratorStack
): NavigationItem | undefined {
    if (!stack || stack.length === 0) {
        return undefined;
    }
    const stackRemain: QueryIteratorStack = stack.slice(0, -1) || [];
    const [top]: (QueryIteratorStackEntry | undefined)[] = stack.slice(-1) || undefined;

    return {
        label: top?.backToLangkey,
        navigationLink: {
            route: top?.pageUrl,
            extras: {
                state: {
                    page: el?.current.page,
                    queryIteratorId: top.queryIteratorId,
                    queryIteratorStack: stackRemain
                }
            }
        },
        icon: 'arrow-left',
        iconPosition: NavigationItemIconPosition.Start
    };
}

export function getPreviousNavigationItem(
    el: ActiveElementReference | undefined,
    stack: QueryIteratorStack,
    label: string
): NavigationItem | undefined {
    if (!el || !el.prev || stack.length === 0) {
        return undefined;
    }
    return {
        label,
        navigationLink: {
            route: `../${el.prev.id}`,
            extras: {
                state: {
                    queryIteratorStack: stack
                }
            }
        },
        icon: 'angle-left',
        iconPosition: NavigationItemIconPosition.Start
    };
}

export function getNextNavigationItem(
    el: ActiveElementReference | undefined,
    stack: QueryIteratorStack,
    label: string
): NavigationItem | undefined {
    if (!el || !el.next || stack.length === 0) {
        return undefined;
    }
    return {
        label,
        navigationLink: {
            route: `../${el.next.id}`,
            extras: {
                state: {
                    queryIteratorStack: stack
                }
            }
        },
        icon: 'angle-right',
        iconPosition: NavigationItemIconPosition.End
    };
}
